/* unplugin-vue-components disabled */import { render } from "./apollo-link.vue?vue&type=template&id=637f3f90&scoped=true"
import script from "./apollo-link.vue?vue&type=script&lang=js"
export * from "./apollo-link.vue?vue&type=script&lang=js"

import "./apollo-link.vue?vue&type=style&index=0&id=637f3f90&lang=stylus"
import "./apollo-link.vue?vue&type=style&index=1&id=637f3f90&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-637f3f90"],['__file',"src/controls/apollo-link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "637f3f90"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('637f3f90', __exports__)) {
    api.reload('637f3f90', __exports__)
  }
  
  module.hot.accept("./apollo-link.vue?vue&type=template&id=637f3f90&scoped=true", () => {
    api.rerender('637f3f90', render)
  })

}


export default __exports__